import columns from '../../../../../../react-table/helpers/columns';
import ReportDefinitions from '../../../../../../common/config/ReportDefinitions';

export function getReceptaclesTabNavigationProps(rowInfo) {
  return rowInfo && rowInfo.row ? {
    reportId: ReportDefinitions.RECEPTACLES_PREDES_RESDES_ANALYSIS.id,
    mainReportId: ReportDefinitions.IPC_TRAY_IL_PREDES_RESDES_ANALYSIS.id,
    selectionCriteriaOptions: {
      includeSelectionCriteria: true,
    },
  } : {};
}
export default (data) => {
  const {
    DateTimeColumn,
    TextColumn,
    NonZeroNumberColumn,
    NonZeroPercentageColumn,
    NavigationColumn,
  } = columns(data);

  return [
    {
      Header: 'PREDES',
      columns: [
        new DateTimeColumn('Despatch closed', 'predes.despatchCloseDate'),
        new TextColumn('Origin IMPC', 'predes.originImpc'),
        new TextColumn('Destination IMPC', 'predes.destinationImpc'),
        new NavigationColumn(new NonZeroNumberColumn('Receptacles', 'predes.receptaclesCount'), getReceptaclesTabNavigationProps),
        new NavigationColumn(new NonZeroNumberColumn('IL', 'predes.matchingType'), getReceptaclesTabNavigationProps),
      ],
    },
    {
      Header: 'RESDES',
      columns: [
        new NavigationColumn(new NonZeroNumberColumn('No response', 'resdes.noResponse'), getReceptaclesTabNavigationProps),
        new NonZeroPercentageColumn('% No response', 'resdes.noResponsePercentage'),
        new NavigationColumn(new NonZeroNumberColumn('IL', 'resdes.match'), getReceptaclesTabNavigationProps),
        new NonZeroPercentageColumn('% IL', 'resdes.matchPercentage'),
        new NavigationColumn(new NonZeroNumberColumn('Non-IL', 'resdes.noMatch'), getReceptaclesTabNavigationProps),
        new NonZeroPercentageColumn('% Non-IL', 'resdes.noMatchPercentage'),
        new TextColumn('Receptacle types', 'resdes.types'),
        new NavigationColumn(new NonZeroNumberColumn('IL, PREDES non-IL', 'resdes.matchWithoutPredes'), getReceptaclesTabNavigationProps),
        new NonZeroPercentageColumn('% IL, PREDES non-IL', 'resdes.matchWithoutPredesPercentage'),
      ],
    },
    {
      Header: 'PREDES',
      columns: [
        new TextColumn('Receptacle types', 'predes.types'),
      ],
    },
  ];
};
